(function(){
  document.addEventListener('DOMContentLoaded', function() {

    // js/custom-element/section/cart/free-shipping-bar.js
    var FreeShippingBar = class extends HTMLElement {
      connectedCallback() {
        document.documentElement.addEventListener("cart:updated", this._onCartUpdated.bind(this));
      }
      get threshold() {
        return parseFloat(this.getAttribute("threshold"));
      }
      _onCartUpdated(event) {
        this.style.setProperty("--progress", Math.min(parseFloat(event.detail["cart"]["total_price"]) / this.threshold, 1));
      }
    };
    window.customElements.define("free-shipping-bar", FreeShippingBar);

    document.addEventListener('click', function(e) {
      if ( e.target.matches('.variant_add_to_cart') || e.target.closest('.variant_add_to_cart')) {
        e.preventDefault();
        let checkbox = e.target.closest('.variant_wrapper')?.querySelector('label');
        checkbox?.click();
        setTimeout(function() {
          let addToCart = document.querySelector('product-info .product-form__submit');
          addToCart?.click();
        }, 1000);
      }
    });

    
    /**
    * code for position sticky header
    */
    function handleHeaderPosition() {
      let header = document.querySelector('.shopify-section-group-header-group.section-header');
      let announcementBarSection = document.querySelector('.announcement-bar-section');
      if ( ! header || ! announcementBarSection ) { 
        header.style.top = 0;
      } else {
        header.style.top = announcementBarSection.offsetHeight + 'px';
      }
      
    }
    handleHeaderPosition();
    
    var playButton = document.querySelectorAll('.banner_section .video-section__poster');
    if ( playButton ) {
      setTimeout(function() {
        playButton.forEach( elem => {
          elem.click();
          window.scrollBy(0,2);
        });
        document.addEventListener("scroll", (event) => {
          var videoelem = document.querySelectorAll('.banner_section video');
          videoelem.forEach( elem => {
            elem.play();
          });
        });
        document.addEventListener("touchstart", (event) => {
          var videoelem = document.querySelectorAll('.banner_section video');
          videoelem.forEach( elem => {
            elem.play();
          });
        });
      }, 100);
    }
    
    
    
     
    /*
    * start code for hover menu open
    */
    // const inlineMenu = document.querySelectorAll(".header__inline-menu");
    const detailsItems = document.querySelectorAll(".header__inline-menu details");
      detailsItems.forEach(item => {
        const ulElement = item.querySelector("ul");
        item.addEventListener("mouseover", () => {
          item.setAttribute("open", true);
          ulElement.addEventListener("mouseleave", () => {
            item.removeAttribute("open");
          });
          item.addEventListener("mouseleave", () => {
            item.removeAttribute("open");
          });
        });
      });
     /*
    * end start code for hover menu open
    */

    
    console.log('jsfile');
    window.initJsSlideProduct = () => {

      function isVideoPlay(that) {
        if ( document.querySelectorAll('.js-product-main-slider .swiper-slide-active .deferred-media__poster')?.length > 0 ) {
          document.querySelector('.js-product-main-slider .swiper-slide-active .deferred-media__poster').click();
          
          setTimeout(() => {
            // console.log("Delayed for 1 second.");
             if ( document.querySelector('.js-product-main-slider .swiper-slide-active video')?.length > 0 ) {
              let video = document.querySelector('.js-product-main-slider .swiper-slide-active video');
              try {
                video[0].play();
              } catch (error) {
                console.log(error);
              }
            }
          }, "1000");
        }
        if ( document.querySelectorAll('.js-product-main-slider .swiper-slide-active video')?.length > 0 ) {
          let video = document.querySelector('.js-product-main-slider .swiper-slide-active video');
          
          try {
            video[0].play();
          } catch (error) {
            console.log(error);
          }
        }
      }

      function playVideoOnActiveSlide(swiperInstance) {
        // Pause all existing videos
        let videos = document.querySelectorAll(
          ".js-product-main-slider video"
        );
        videos.forEach(function (video) {
          video.pause();
          video.currentTime = 0;
        });

        // Find the active slide
        let activeSlide = document.querySelector(
          ".js-product-main-slider .swiper-slide-active"
        );

        if (activeSlide) {
          // Check if a video is already present in the slide
          let video = activeSlide.querySelector("video");

          // If video not yet loaded, load it from the <template>
          if (!video) {
            let template = activeSlide.querySelector("template");
            if (template) {
              // Clone the video node from the template
              let videoElement = template.content
                .querySelector("video")
                .cloneNode(true);

              // Insert the video into the slide (you can append to a container if needed)
              activeSlide.appendChild(videoElement);

              // Optional: add a slight delay to ensure it’s properly rendered before play
              setTimeout(() => {
                videoElement.play();
              }, 100);
            }
          } else {
            // If video already exists, just play it
            video.play();
          }
        }
      }

      let containerProduct = document.querySelectorAll('product-info');
      containerProduct.forEach(elem => {
        let thumbItem = elem.querySelector('.js-product-thumbnail-slider');
        // let sliderThumbnail = new Swiper(thumbItem, {
        //   direction: 'vertical', // Set direction to vertical
        //   spaceBetween: 11,
        //   autoHeight: true,
        //   mousewheel: true,
        //   slidesPerView: 5,
        //   freeMode: true,
        //   on:{
        //     slideChangeTransitionEnd:function(){
        //       isVideoPlay(this);
        //     }
        //   },
        //   breakpoints: {
        //     // when window width is >= 320px
        //     320: {
        //       slidesPerView: 4,
        //     },
        //     // when window width is >= 640px
        //     640: {
        //       slidesPerView: 5,
        //     }
        //   }
        // });

        var sliderThumbnail = new Swiper(thumbItem, {
            spaceBetween: 11,
            slidesPerView: 5,
            mousewheel: true,
            autoHeight: true,
            loop: true,
            watchOverflow: true,
            centeredSlides: false,
            centerInsufficientSlides: true,
            freeMode: false,
            // RTL will be automatically handled by Swiper if your page uses dir="rtl"
            on: {
              slideChangeTransitionEnd: function () {
                isVideoPlay(this);
                playVideoOnActiveSlide(this);
              },
            },
            breakpoints: {
              320: {
                slidesPerView: 5,
                spaceBetween: 5,
                centeredSlides: false,
                centerInsufficientSlides: true,
                loop: true,
                direction: "horizontal", // Don't manually flip, Swiper handles RTL
                freeMode: false,
              },
              640: {
                slidesPerView: 5,
                direction: "vertical", // Vertical doesn't care about RTL
                freeMode: false,
              },
            },
          });
    
        let mainItem = elem.querySelector('.js-product-main-slider');
        let galleryMain = new Swiper(mainItem, {
          // navigation: {
          //   nextEl: '.swiper-button-next',
          //   prevEl: '.swiper-button-prev',
          // },
          thumbs: {
            swiper: sliderThumbnail,
          },
          // autoHeight: true,
          on: {
            slideChangeTransitionEnd: function () {
              isVideoPlay(this);
              playVideoOnActiveSlide(this);
            },
          },
          breakpoints: {
            // when window width is >= 320px
            320: {
              slidesPerView: 1,
              centeredSlides: true,
              loop: true,
              // initialSlide: 1,
              spaceBetween: 0,
            },
            // when window width is >= 640px
            767: {
              slidesPerView: 1,
            },
          },
        });
      });
      
    }
    window.initJsSlideProduct();

    function setTagsForRegisterForm() {
      let birthdayField = document.querySelector('[name="customer[birthday]"]');
      let customerTags = document.querySelector('[name="customer[note]"]');
      if ( ! birthdayField || ! customerTags ) return false;

      birthdayField.addEventListener('change', function(e) {
        e.preventDefault();
        customerTags.value = `birthday:${birthdayField.value}`;
      })
    }
    setTagsForRegisterForm();

    function fixPlaceholderDateIOS() {
      let dateLabel = document.querySelector('.birthday_wrap label');
      let dateInput = document.querySelector('.birthday_wrap input');
      if ( ! dateInput || ! dateLabel ) return false;
      // При фокусе убираем плейсхолдер (чтобы не мешал селектору)
      dateInput.addEventListener('click', () => {
        dateInput.placeholder = '';
      });

      // При потере фокуса возвращаем плейсхолдер
      dateInput.addEventListener('blur', () => {
        if (!dateInput.value) {
          dateInput.placeholder = 'mm/dd/yyyy';
        }
      });
    }
    // fixPlaceholderDateIOS();

 }, false);
})();
